export default __webpack_public_path__ + "static/media/Path 103.62096272.svg";